module.exports = __webpack_public_path__ + "static/img/datiTitle.981a87b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/datiTitle.png
// module id = +oqV
// module chunks = 0